module.exports = __webpack_public_path__ + "media/era_sweepstakes/instagram-6e059e8a.svg";